type Megamenu = {
  init: () => void;
  setMegamenu: () => void;
};

const megamenu: Megamenu = {
  init(): void {
    this.setMegamenu();
  },

  setMegamenu(): void {
    document.addEventListener('DOMContentLoaded', () => {
      const sublists = document.querySelectorAll<HTMLUListElement>(
        '.desk-nav__sublist-list'
      );

      sublists.forEach((ul) => {
        if (ul.dataset.megamenuReady === 'true') return;

        ul.dataset.megamenuReady = 'true';

        const levelTwoItems = Array.from(
          ul.querySelectorAll<HTMLLIElement>('.desk-nav__subitem--lvl2')
        );

        if (levelTwoItems.length <= 1) return;
        
        const hasNested = levelTwoItems.some((li) => li.querySelector('ul'));
        const columns = hasNested ? 6 : 4;
        const perColumn = Math.ceil(levelTwoItems.length / columns);

        ul.innerHTML = '';

        for (let i = 0; i < columns; i++) {
          const columnItems = levelTwoItems.slice(
            i * perColumn,
            (i + 1) * perColumn
          );

          if (!columnItems.length) continue;

          const columnWrapper = document.createElement('li');
          columnWrapper.className = 'desk-nav__column';

          columnItems.forEach((li) => {
            columnWrapper.appendChild(li);
          });

          ul.appendChild(columnWrapper);
        }
      });
    });
  },
};

export default megamenu;